module.exports = __webpack_public_path__ + "static/media/logo.0938a2c9.svg";